import React, { FC } from 'react';
import CommentIcon from '../Icons/CommentIcon';

type TCommentThreadButtonProps = {
  onClick: () => void;
  childCommentsCount: number;
};

const CommentThreadButton: FC<TCommentThreadButtonProps> = ({ onClick, childCommentsCount }) => (
  <div className="relative flex w-10 items-center gap-x-3">
    <button
      value={childCommentsCount}
      onClick={onClick}
      className="relative h-8 flex items-center active:-ml-[6px] active:justify-center stroke-gray-600 active:bg-red-100 active:w-8 active:h-8 active:rounded-full hover:!stroke-orange-500 hover:text-orange-500 after:absolute after:left-8 after:top-1 after:content-[attr(value)] after:text-gray-600 after:hover:text-orange-500 after:active:ml-[6px]"
    >
      <CommentIcon />
    </button>
  </div>
);

export default CommentThreadButton;
